
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('mask',{attrs:{"id":"a","height":"24","maskUnits":"userSpaceOnUse","width":"24","x":"0","y":"0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"#fff"}})]),_c('path',{attrs:{"d":"M10.2 17.2c-3.8 0-6.9-3.1-6.9-6.9s3.1-6.9 6.9-6.9 7 3.1 7 6.9-3.1 6.9-7 6.9m13.3 4l-5-5c1.3-1.7 1.9-3.8 1.9-6C20.5 4.6 15.9 0 10.2 0 4.6 0 0 4.6 0 10.2c0 5.7 4.6 10.2 10.2 10.2 2.2 0 4.2-.7 6-1.9l5 5c.3.3.8.5 1.2.5s.9-.2 1.2-.5c.5-.6.6-1.6-.1-2.3z","mask":"url(#a)"}})])
      }
    
      }
    